import { render } from "./Categories.vue?vue&type=template&id=ac610314&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=ac610314&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ac610314"

export default script